const TableNumber = ({ tableNumber, orderType }) => {
    return (
        <div className="flex items-center justify-between px-4 py-3">
            <div className="text-sm font-semibold text-gray-700">
                {
                    orderType == 'dinein' ? 'Nomor Meja' 
                    : orderType == 'pickup' ? 'Antrian'
                    : 'Nomor Meja / Antrian'
                }
            </div>

            <div className="min-w-[36px] h-[36px] flex items-center justify-center rounded-lg bg-gray-100 border border-gray-200 text-sm font-semibold text-gray-700">
                {tableNumber}
            </div>
        </div>
    );
};

export default TableNumber;